// extracted by mini-css-extract-plugin
export default {"legendsContainer":"styles_legendsContainer__rPX7X","item":"styles_item__w3JvI"};